import { connect, Dispatch } from 'react-redux';

import { Action } from '../../actions';
import { updateInternalMarketerProductAction } from '../../actions/marketer/internal/updateInternalMarketerProduct';
import { updateInternalMarketerProductAccessAction } from '../../actions/marketer/internal/updateInternalMarketerProductAccess';
import {
    MarketerProductAccessCell,
    MarketerProductAccessCellProps
} from '../../components/MarketerProductAccessCell/MarketerProductAccessCell';
import { ServerMarketerAccess } from '../../typings/marketers';
import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

type OwnProps = Pick<MarketerProductAccessCellProps, 'product'>;
type StateProps = TStateProps<MarketerProductAccessCellProps, OwnProps>;
type DispatchProps = TDispatchProps<MarketerProductAccessCellProps, OwnProps>;

const mapStateToProps = (state: State): StateProps => ({
    pageStatus: state.marketerCard.pageStatus,
    places: state.internalProductPlaces.places,
    accessRights: state.commonData.accessRights,
    isGridScrolling: state.grid.isGridScrolling
});

const mapDispatchToProps = (dispatch: Dispatch<Action>, ownProps: OwnProps): DispatchProps => ({
    onCancel: () => dispatch(updateInternalMarketerProductAction(ownProps.product, { isSaved: true })),
    onEdit: () => dispatch(updateInternalMarketerProductAction(ownProps.product, { isSaved: false })),
    onSave: (accessType: ServerMarketerAccess, placeIds: number[]) =>
        dispatch(updateInternalMarketerProductAccessAction(ownProps.product.id, accessType, placeIds))
});

const mergeProps = (
    stateProps: StateProps,
    dispatchProps: DispatchProps,
    ownProps: OwnProps
): MarketerProductAccessCellProps => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps
});

export const MarketerProductAccessCellContainer = connect<
    StateProps,
    DispatchProps,
    OwnProps,
    MarketerProductAccessCellProps
>(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(MarketerProductAccessCell);
